export const DATA_NOT_CHANGED_SO_NOT_UPDATED = 'Nothing to update as no changes were made to the data';


// WEBPACK FOOTER //
// ./constants/messages.js